<cs-icon-button
  class="btn-close"
  iconType="icon"
  icon="fi-x"
  color="secondary"
  size="12"
  (buttonClick)="close()"
></cs-icon-button>
<div class="wrapper">
  <div class="heading">Claim BONUS</div>
  <div class="cont">
    <div class="item">
      <p>Claim your bonus in the currency of your choice.</p>
    </div>
    <div class="item">
      <div class="label">Select currency</div>
      <cs-select [(value)]="targetCurrency" [options]="cryptoList" (valueChange)="currencyChange()"></cs-select>
    </div>
    <div class="item space-between">
      <div class="name">Estimated received amount</div>
      <div class="amount">
        <span>{{ targetAmount | currencyValue: targetCurrency }}</span>
        <img [src]="targetCurrency | currencyIcon" alt="" />
      </div>
    </div>
    <cs-button label="Claim" size="large" [loading]="loading" (buttonClick)="claimBonus(InjectItem)"></cs-button>
  </div>
</div>
